/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { selectNow } from '@zcode-ui/web-zumper-global-state'
import { type MoveInDateInputProps, getMoveInDateFromMoveInText } from '@zcode-ui/web-zumper-ui'
import { selectIsLoggedIn } from '@zcode/nr/es/shared/modules/user/selectors'
import type { Dispatch } from 'redux'
import { moveInTextValidator } from '../../../packages/Inputs/validator/moveIn'
import type { GetState } from '../../types'
import { selectFetchedProfile, selectProfileMoveInValue } from '../selectors/index'
import { loadProfile } from './loadProfile'

// @ts-expect-error not quite the correct type guard
export const isValidMoveInText: (
  moveInText: string
) => moveInText is NonNullable<Parameters<MoveInDateInputProps['onSelectMoveInDate']>[1]> = (
  moveInText
) => moveInTextValidator.isValidSync(moveInText)

export const getRefreshedMoveInDate = () => async (dispatch: Dispatch, getState: GetState) => {
  let state = getState()
  const fetchedProfile = selectFetchedProfile(state)
  const isLoggedIn = selectIsLoggedIn(state)
  if (!fetchedProfile && isLoggedIn) {
    await dispatch(loadProfile('MOVE_IN'))
  }
  state = getState()
  const savedMoveInText = selectProfileMoveInValue(state)
  const now = selectNow(state)
  // see also similiar logic in getInitialFormValues.ts; probably need to update both together
  if (typeof savedMoveInText === 'string' && isValidMoveInText(savedMoveInText)) {
    return {
      refreshedMoveInDate: getMoveInDateFromMoveInText(savedMoveInText, now),
      savedMoveInText,
    }
  }
  return { refreshedMoveInDate: undefined, savedMoveInText: undefined }
}
